import * as React from "react";
import { useEffect } from "react";

import { Badge } from "../badge/Badge";
import { Command, CommandGroup, CommandItem } from "../command/Command";
import { Command as CommandPrimitive } from "cmdk";
import { Cross1Icon } from "@radix-ui/react-icons";
import FixedScrollArea from "../scroll-area/FixedScrollArea";

export function MultiSelect({
  options,
  placeholder = "Seleccione uno",
  onValueChange,
  isDisabled = false,
}) {
  const inputRef = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");

  const handleUnselect = (option) => {
    const input = inputRef.current;
    setSelected((prev) => {
      input.blur();
      const newSelected = prev.filter((s) => s.value !== option.value);
      onValueChange(newSelected.map((s) => s.value));
      return newSelected;
    });
  };

  const selectables =
    options === undefined
      ? []
      : options.filter((option) => !selected.includes(option));

  useEffect(() => {
    if (options?.length === 0) {
      setSelected([]);
      setInputValue("");
    }
  }, [options]);

  return (
    <Command className="overflow-visible bg-transparent">
      <div
        className={`${
          isDisabled ? "bg-slate-100" : ""
        } group border border-input px-3 py-2 text-sm ring-offset-background rounded-md focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2`}
      >
        <div className="flex gap-1 flex-wrap">
          {selected.map((option) => {
            return (
              <Badge key={option.value} variant="secondary">
                {option.label}
                <button
                  className="ml-1 ring-offset-background rounded-full outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleUnselect(option);
                    }
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onClick={() => handleUnselect(option)}
                >
                  <Cross1Icon className="h-3 w-3 text-muted-foreground hover:text-foreground" />
                </button>
              </Badge>
            );
          })}
          {/* Avoid having the "Search" Icon */}
          <CommandPrimitive.Input
            ref={inputRef}
            value={inputValue}
            onValueChange={setInputValue}
            onBlur={() => setOpen(false)}
            onFocus={() => setOpen(true)}
            placeholder={placeholder}
            className="ml-2 bg-transparent outline-none placeholder:text-muted-foreground flex-1"
            disabled={isDisabled}
          />
        </div>
      </div>
      <div className="relative mt-2">
        {open && selectables.length > 0 ? (
          <div className="absolute w-full z-10 top-0 rounded-md border bg-popover text-popover-foreground shadow-md outline-none animate-in">
            <CommandGroup className="h-full overflow-auto">
              <FixedScrollArea
                className={selectables.length >= 6 ? "h-48" : ""}
              >
                {selectables.map((option) => {
                  return (
                    <CommandItem
                      key={option.value}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onSelect={(value) => {
                        const input = inputRef.current;
                        input.blur();
                        setInputValue("");
                        setSelected((prev) => [...prev, option]);
                        const newSelected = [...selected, option];
                        onValueChange(newSelected.map((item) => item.value));
                      }}
                      className={"cursor-pointer"}
                    >
                      {option.label}
                    </CommandItem>
                  );
                })}
              </FixedScrollArea>
            </CommandGroup>
          </div>
        ) : null}
      </div>
    </Command>
  );
}
